/**
 * File & PDF API Endpoints
 * Centralizes all file download and PDF generation API calls.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { EntityPayload } from "../../types/api";

export const fileApi = {
  /** Download stored files (invoice PDFs / certificates) by id or seminar. */
  downloadPdf: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post(
      "/api/files",
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        timeout: 360000, // 6 minutes for large downloads
      }
    ),

  /** Generate PDF documents (JSON envelope response). */
  generatePdf: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post(
      "/api/pdfgen",
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        timeout: 360000, // 6 minutes for PDF generation
      }
    ),

  /**
   * Generate a PDF and receive the raw binary. Used for the ad-hoc documents
   * (Teilnehmerliste / Tischkarten / Bewertungsbogen) where the backend returns
   * the PDF bytes directly (not a JSON envelope), so we must read the response
   * as an ArrayBuffer or axios mangles the binary into a corrupt string.
   */
  generatePdfBinary: (data: EntityPayload): Promise<AxiosResponse<ArrayBuffer>> =>
    api.post(
      "/api/pdfgen",
      { data },
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        timeout: 360000,
      }
    ),
};
